import ErrorBoundaryContainer from './ErrorBoundaryContainer';

export default ErrorBoundaryContainer;
